import { type UseMutationResult, useMutation } from '@tanstack/react-query'
import {
  type RequestError,
  extractHttpError,
} from 'components/api/extractHttpError'
import { API_PREFIX } from 'config'
import ky from 'ky'

import { logEvents } from '../../logEvents'

export const useSummarize = (
  apiToken: string,
): UseMutationResult<
  { summary: string },
  RequestError,
  { queue: string | null; transcription: string }
> => {
  return useMutation({
    mutationKey: ['live-summary'],
    mutationFn: async (payload) => {
      try {
        return await ky
          .post(
            `${API_PREFIX}/co-pilot/v1/summaries/summarise?token=${apiToken}`,
            {
              json: payload,
              credentials: 'include',
              mode: 'cors',
              timeout: 300_000, // 5 minutes
            },
          )
          .json<{ summary: string }>()
      } catch (error) {
        const e = await extractHttpError(error)
        logEvents({
          eventType: 'useSummarize error',
          level: 'error',
          name: e.name,
          message: e.message,
          ...e.cause,
        })

        throw e
      }
    },
  })
}
